<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="3">
                    <v-radio-group class="mt-2" v-model="tipo" row>
                        <v-radio label="Producto" color="success" value="producto"></v-radio>
                        <v-radio label="Material" color="success" value="material"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-caption' v-model="sku" label="Sku" outlined dense rounded></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-btn @click="searchProducts()" class="mt-1" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                </v-col>                
                <v-col cols="4">
                    <v-text-field class='text-caption' v-model="producto" label="Producto" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                </v-col>
                <!-- <v-col cols="1">
                    <v-btn class="mt-1" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                </v-col> -->
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="3">
                    <v-alert class='text-caption' v-if="existe=='si'" shaped dense text type="success">
                        Existe !!!
                    </v-alert>
                    <v-alert class='text-caption' v-else-if="existe=='no'" shaped dense text type="warning">
                        Nueva !!!
                    </v-alert>
                    <v-alert class='text-caption' v-else dense shaped text type="info">
                        Selecciona Producto o Material !!!
                    </v-alert>
                </v-col >
                <v-col cols="2">
                    <v-select class='text-caption' v-model="categoria" :items="categorias" label="Categoria" item-text="categoria" item-value="id" dense outlined rounded :filled="filled" :disabled="disabled"></v-select>
                </v-col>
                <v-col cols="3">
                    <v-text-field class='text-caption' v-model="marca" label="Marca" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field class='text-caption' v-model="variante" label="Variante" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="4">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea class='text-caption' no-resize rows="4" outlined dense rounded v-model="descripcion" label="Descripcion" :filled="filled" :disabled="disabled"></v-textarea>                                
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="8">
                    <v-row class="mt-0">
                        <v-col cols="3">
                            <v-select class='text-caption' v-model="medida" :items="medidas" label="Medida" dense outlined rounded :filled="filled" :disabled="disabled"></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="peso" label="Peso (kg)" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="volumen" label="Volumen (cm3)" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="barra" label="Cod. Barra" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n7">
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="precio_detalle" label="Precio Detalle" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="precio_oferta" label="Precio Oferta" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-caption' v-model="precio_mayor" label="Precio Mayor" outlined dense rounded :filled="filled" :disabled="disabled"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-select class='text-caption' v-model="estado" :items="estados" label="Estado" dense outlined rounded :filled="filled" :disabled="disabled"></v-select>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-container>
                <div class="mt-n2">
                    <v-row>
                        <v-col cols="2" class="mt-n5 text-end">
                            <form method="post" action="#" enctype="multipart/form-data">
                                <div>
                                    <v-icon @click="deleteImage(1)" class="mr-2">cancel</v-icon>
                                    <label for="file1"><v-icon>add_circle</v-icon></label>
                                    <img src="" id="img1"/>
                                    <input type="file" name="file1" id="file1" accept="image/*" /><br/>
                                </div>
                            </form>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <form method="post" action="#" enctype="multipart/form-data">
                                <div>
                                    <v-icon @click="deleteImage(2)" class="mr-2">cancel</v-icon>
                                    <label for="file2"><v-icon>add_circle</v-icon></label>
                                    <img src="" id="img2"/>
                                    <input type="file" name="file2" id="file2" accept="image/*" /><br/>
                                </div>
                            </form>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <form method="post" action="#" enctype="multipart/form-data">
                                <div>
                                    <v-icon @click="deleteImage(3)" class="mr-2">cancel</v-icon>
                                    <label for="file3"><v-icon>add_circle</v-icon></label>
                                    <img src="" id="img3"/>
                                    <input type="file" name="file3" id="file3" accept="image/*" /><br/>
                                </div>
                            </form>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <form method="post" action="#" enctype="multipart/form-data">
                                <div>
                                    <v-icon @click="deleteImage(4)" class="mr-2">cancel</v-icon>
                                    <label for="file4"><v-icon>add_circle</v-icon></label>
                                    <img src="" id="img4"/>
                                    <input type="file" name="file4" id="file4" accept="image/*" /><br/>
                                </div>
                            </form>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <form method="post" action="#" enctype="multipart/form-data">
                                <div>
                                    <v-icon @click="deleteImage(5)" class="mr-2">cancel</v-icon>
                                    <label for="file5"><v-icon>add_circle</v-icon></label>
                                    <img src="" id="img5"/>
                                    <input type="file" name="file5" id="file5" accept="image/*" /><br/>
                                </div>
                            </form>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <form method="post" action="#" enctype="multipart/form-data">
                                <div>
                                    <v-icon @click="deleteImage(6)" class="mr-2">cancel</v-icon>
                                    <label for="file6"><v-icon>add_circle</v-icon></label>
                                    <img src="" id="img6"/>
                                    <input type="file" name="file6" id="file6" accept="image/*" /><br/>
                                </div>
                            </form>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="mt-4"></v-divider>
                <v-row class="mt-3">
                    <v-col cols="4"></v-col>
                    <v-col cols="2">
                        <v-btn @click="clsInput()" color="teal" rounded dark small block>Nuevo</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn v-if="btn_grabado!=true" @click="goSave()" color="teal" rounded dark small block>Grabar</v-btn>
                        <v-btn v-else color="grey" rounded dark small block>Grabar</v-btn>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>
            </v-container>
        </v-container>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
form img{
  width: 150px;
  height: 150px;
  /* border-radius: 50%; */
  border: 2px solid #AAA;
}
form div:first-child{
  align-items: center;
}
form div:first-child input{
  display: none;
}
form div:first-child label{
  /* background: #1F5F74;
  color: white; 
    border-radius: 3px; 
  padding: 6px 20px;*/
  cursor: pointer;
}
form input{
  padding: 8px 20px;
  border: 1px solid #AAA;
  border-radius: 3px;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Productos',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    categorias:[],
    medidas:['UN','MT','KG','LT'],
    estados:['V','N'],

    existe:'',
    tipo:'producto',
    sku:'',
    producto:'',
    descripcion:'',
    categoria:'',
    marca:'',
    variante:'',
    medida:'',
    peso:0,
    volumen:0,
    barra:'',
    precio_oferta:'',
    precio_detalle:'',
    precio_mayor:'',
    estado:'',
    filled:true,
    disabled:true,
    btn_grabado:false,
    bloqueo:null,
    loading:false,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    await this.serachCategory();
    //listener de imagenes 1
    const file1 = document.getElementById( 'file1' );
    const img1 = document.getElementById( 'img1' )
    file1.addEventListener( 'change', e => {
        img1.src = '' ;
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img1.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img1.src = '';
        }        
    });
    //listener de imagenes 2
    const file2 = document.getElementById( 'file2' );
    const img2 = document.getElementById( 'img2' );
    file2.addEventListener( 'change', e => {
        img2.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img2.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img2.src = '';
        }        
    });
    //listener de imagenes 3
    const file3 = document.getElementById( 'file3' );
    const img3 = document.getElementById( 'img3' );
    file3.addEventListener( 'change', e => {
        img3.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img3.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img3.src = '';
        }        
    });
    //listener de imagenes 4
    const file4 = document.getElementById( 'file4' );
    const img4 = document.getElementById( 'img4' );
    file4.addEventListener( 'change', e => {
        img4.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img4.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img4.src = '';
        }        
    });
    //listener de imagenes 5
    const file5 = document.getElementById( 'file5' );
    const img5 = document.getElementById( 'img5' );
    file5.addEventListener( 'change', e => {
        img5.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img5.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img5.src = '';
        }        
    });
    //listener de imagenes 6
    const file6 = document.getElementById( 'file6' );
    const img6 = document.getElementById( 'img6' );
    file6.addEventListener( 'change', e => {
        img6.src = '';
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img6.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img6.src = '';
        }        
    });
    this.bloqueo = await this.myPermiso(3);
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async serachCategory(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                categoria : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/category/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.categorias=datos
            }            
        } catch (error) {
            console.log(error)
        }
    },
    clsInput(){
        this.existe='';
        this.tipo='producto';
        this.sku='';
        this.producto='';
        this.descripcion='';
        this.categoria='';
        this.marca='';
        this.variante='';
        this.medida='';
        this.peso=0;
        this.volumen=0;
        this.barra='';
        this.precio_oferta='';
        this.precio_detalle='';
        this.precio_mayor='';
        this.estado='';
        document.getElementById( 'img1' ).src = '';
        document.getElementById( 'img2' ).src = '';
        document.getElementById( 'img3' ).src = '';
        document.getElementById( 'img4' ).src = '';
        document.getElementById( 'img5' ).src = '';
        document.getElementById( 'img6' ).src = '';
        this.filled=true;
        this.disabled=true;
        this.btn_grabado=false;
    },
    async searchProducts(){
        if(this.sku!='all' && this.sku!=''){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    sku :  this.sku
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    const element = datos[0];
                    this.tipo = element.tipo
                    this.sku = element.codigo
                    this.producto = element.producto
                    this.descripcion = element.descripcion
                    this.categoria = element.categoria
                    this.marca = element.marca
                    this.variante = element.variante
                    this.medida = element.medida
                    this.peso = element.peso
                    this.volumen = element.volumen
                    this.barra = element.barra
                    this.precio_detalle = element.precio_detalle
                    this.precio_oferta = element.precio_oferta
                    this.precio_mayor = element.precio_mayor
                    document.getElementById( 'img1' ).src = element.img1;
                    document.getElementById( 'img2' ).src = element.img2;
                    document.getElementById( 'img3' ).src = element.img3;
                    document.getElementById( 'img4' ).src = element.img4;
                    document.getElementById( 'img5' ).src = element.img5;
                    document.getElementById( 'img6' ).src = element.img6;
                    this.estado = element.estado
                    this.existe='si';
                    this.filled=false;
                    this.disabled=false;
                } else {
                    if(datos[0].existe=='no'){
                        this.existe='no';
                        this.filled=false;
                        this.disabled=false;
                    } else {
                        this.color_snack='error';
                        this.mensaje='Inconsistencia en los datos, informar a soporte';
                        this.snack=true
                    }
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Algo salio mal, informar a soporte';
                this.snack=true
            }
            this.loading=false;
        }
    },
    async goSave(){
        this.loading=true;
        this.btn_grabado=true;
        if(this.existe=="no"){ await this.saveProduct() };
        if(this.existe=="si"){ await this.updateProduct() };
        this.loading=false;
    },
    async saveProduct(){
        try {
            //obtener las fotos
            let fotos=['','','','','','']
            fotos[0]=document.getElementById( 'img1' ).src;
            fotos[1]=document.getElementById( 'img2' ).src;
            fotos[2]=document.getElementById( 'img3' ).src;
            fotos[3]=document.getElementById( 'img4' ).src;
            fotos[4]=document.getElementById( 'img5' ).src;
            fotos[5]=document.getElementById( 'img6' ).src;
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                tipo : this.tipo,
                codigo : this.sku,
                producto : this.producto,
                descripcion : this.descripcion,
                categoria : this.categoria,
                marca : this.marca,
                variante : this.variante,
                medida : this.medida,
                peso : this.peso,
                volumen : this.volumen,
                barra : this.barra,
                precio_oferta : this.precio_oferta,
                precio_detalle : this.precio_detalle,
                precio_mayor : this.precio_mayor,
                estado : this.estado,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/product/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                //update de las fotos
                for (let index = 0; index < fotos.length; index++) {
                    const myFoto = fotos[index];
                    const par = {
                        contrato : this.contrato,
                        user: this.user,
                        id: index,
                        codigo: this.sku,
                        foto: myFoto,
                    };
                    await axios.post(process.env.VUE_APP_URL + '/api/v1/save/photo/',par,{headers});                    
                };
                this.color_snack='success';
                this.mensaje='Producto grabado con exito';
                this.snack=true
            } else {
                this.color_snack='error';
                this.mensaje='No es posible grabar el Producto';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
    },
    async updateProduct(){
        try {
            //obtener las fotos
            let fotos=['','','','','','']
            fotos[0]=document.getElementById( 'img1' ).src;
            fotos[1]=document.getElementById( 'img2' ).src;
            fotos[2]=document.getElementById( 'img3' ).src;
            fotos[3]=document.getElementById( 'img4' ).src;
            fotos[4]=document.getElementById( 'img5' ).src;
            fotos[5]=document.getElementById( 'img6' ).src;
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                tipo : this.tipo,
                codigo : this.sku,
                producto : this.producto,
                descripcion : this.descripcion,
                categoria : this.categoria,
                marca : this.marca,
                variante : this.variante,
                medida : this.medida,
                peso : this.peso,
                volumen : this.volumen,
                barra : this.barra,
                precio_oferta : this.precio_oferta,
                precio_detalle : this.precio_detalle,
                precio_mayor : this.precio_mayor,
                estado : this.estado,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/product/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                //update de las fotos
                for (let index = 0; index < fotos.length; index++) {
                    const myFoto = fotos[index];
                    const par = {
                        contrato : this.contrato,
                        user: this.user,
                        id: index,
                        codigo: this.sku,
                        foto: myFoto,
                    };
                    const result = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/photo/',par,{headers});
                    console.log('resultado', result.data);                    
                };
                this.color_snack='success';
                this.mensaje='Producto actualizado con exito';
                this.snack=true
            } else {
                this.color_snack='error';
                this.mensaje='No es posible actualizar el Producto';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
    },
    deleteImage(key){
        switch (key) {
            case 1:
                document.getElementById( 'img1' ).src=''
            break;
            case 2:
                document.getElementById( 'img2' ).src=''
            break;
            case 3:
                document.getElementById( 'img3' ).src=''
            break;
            case 4:
                document.getElementById( 'img4' ).src=''
            break;
            case 5:
                document.getElementById( 'img5' ).src=''
            break;
            case 6:
                document.getElementById( 'img6' ).src=''
            break;
        }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },

  }
}
</script>
